import React, { Component } from 'react';
import { Field } from 'formik';

import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';
const { cities, jobTypes } = require('buyside/util/constantsFromRails.json');

import styles from './JobDetailsSectionStyles';

class JobDetailsSection extends Component {
  render() {
    const { isMobile } = this.props;

    return (
      <div className={`${styles.container}`}>
        <div className={`${isMobile ? '' : styles.inputContainer}`}>
          <Field
            component={InputField}
            name="positionDetails.city"
            type="select"
            label="JOB LOCATION"
            options={cities.map(({ name }) => name)}
          />
          <div id="job-title">
            <Field
              component={InputField}
              name="positionDetails.title"
              type="select"
              label="JOB TITLE"
              options={jobTypes}
            />
          </div>
        </div>
        <div id="job-description">
          <Field
            component={InputField}
            name="positionDetails.description"
            type="textarea"
            label="JOB DESCRIPTION"
          />
        </div>
        <div className={styles.descriptionWarning}>
          <strong>Note: </strong>Employers must remain anonymous in the Job Vault. Please do not
          include your company name in the description details
        </div>
      </div>
    );
  }
}

export default JobDetailsSection;
